
import {of as observableOf,  Observable, Subscription } from 'rxjs';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, NgForm } from '@angular/forms';
import { PatientsTimelineService } from './patients-timeline.service';
import { AuthService } from '../../../../core/auth.service';
import { BaseService } from '../../../../shared/base.service';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { AppService } from '../../../../app.service';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '../../../../users/users.service';
import { HomeService } from '../../../../home/home.service';
import { SecureApi } from '../../../../core/secure.api';
import {CoreService} from "../../../../core/core.service";
import * as moment from 'moment';
import * as Highcharts from 'highcharts';
import { Chart } from 'highcharts';
import { InsurancePartnerComponent } from '../../insurance-partner.component';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
import exporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';
import offlineExporting from 'highcharts/modules/offline-exporting';
exporting(Highcharts);
exportData(Highcharts);
offlineExporting(Highcharts);
declare module 'highcharts' {
    interface Chart {
        getSVG(): string;
        exportChartLocal(options: Highcharts.ExportingOptions, chartOptions: Highcharts.Options): void;
    }
}

@Component({
    selector: 'patients-timeline-component',
    templateUrl: './patients-timeline.component.html',
    styleUrls: ['./patients-timeline.component.scss'],
    providers: [PatientsTimelineService, BaseService]
})

export class PatientsTimelineComponent extends InsurancePartnerComponent implements OnInit, AfterViewInit {
    @Input() isHome = false;
    @Input() exportData = false;
    @Input() filters;
    roles: Object[] = [];
    isFocusMobileInput: boolean = false;
    userRoleId: number;
    isEditable: boolean = false;
    response: any;
    data = {
        registration_completed : {},
        sr_completed : {},
        appointment_completed : {},
    };
    dataAges = {};
    dataChartsType = [];
    dataLanguages = [];
    message: string;
    filterAge: any;
    chartTypes = [
        {
            name: 'Registrations',
            value: 'registration_completed',
            color: '#6FD8B8'
        },
        {
            name: 'Tests completed',
            value: 'sr_completed',
            color: '#97E3ED'
        },
        {
            name: 'Calls completed',
            value: 'appointment_completed',
            color: '#EF995C'
        }
    ];
    selectedChart = this.chartTypes[1];
    Highcharts: typeof Highcharts = Highcharts; // required
    chartConstructor: string = 'chart'; // optional string, defaults to 'chart'
    chartCallback: Highcharts.ChartCallbackFunction = function (chart) {  } // optional function, defaults to null
    chartOptions: Highcharts.Options = {};
    loadedData = false;
    chartGenerated = false;
    chartBase64: string;
    plotOptions: {};
    chartData = {
        registration_completed : [],
        sr_completed : [],
        appointment_completed : [],
    };
    seriesData = [];
    mockupData = [
        [Date.UTC(1970, 9, 24), 0],
        [Date.UTC(1970, 9, 27), 0.12],
        [Date.UTC(1970, 9, 30), 0.09],
        [Date.UTC(1970, 10, 3), 0.13],
        [Date.UTC(1970, 10, 6), 0.12],
        [Date.UTC(1970, 10, 9), 0.13],
        [Date.UTC(1970, 10, 12), 0.13],
        [Date.UTC(1970, 10, 15), 0.16],
    ];
    activeLanguage = this.appService.activeLanguage.locale;
    subscription: Subscription;

    @ViewChild('formDirective') private formDirective: NgForm;

    constructor(public authService: AuthService,
                public coreService: CoreService,
                public router: Router,
                public translate: TranslateService,
                public fb: FormBuilder,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public homeService: HomeService,
                public clinicService: ClinicsService,
                public secureApi: SecureApi,
                public route: ActivatedRoute,
                public service: PatientsTimelineService) {
        super(authService, router, translate, baseService, appService, usersService, homeService);
    }

    ngOnInit() {
        this.url = 'b2c-patients/mental';
        this.userRoleId = this.authService.user['role_id'];

        // process url query parameters e.g.
        this.route.queryParams.subscribe(params => {
        });
        this.subscription = this.translate.onLangChange.subscribe((event: any) => {
            this.activeLanguage = event.lang;
            return this.generateHighChart();
        });
    }

    ngAfterViewInit() {
    }

    /**
     * @param {SimpleChanges} changes
     */
    ngOnChanges(changes) {
        if (changes['filters']) {
            return this.getItems();
        }
        if (changes['exportData'] && this.exportData) {
            return this.exportToBase64();
        }
    }

    getItems() {
        this.message = 'Fetching data...';
        this.service.getAll(this.filters).subscribe(response => {
            this.loadedData = true;
            this.message = response['message'] || '';
            this.response = response;
            return this.generateHighChart();
        });
    }

    getPercentage(data){
        return 100 - parseFloat(data['low']) - parseFloat(data['medium']);
    }

    generateData(data){
        if(!data){
            return false;
        }
        let result = [];
        for(let item of data){
            let dateTime =  moment(item.day, 'DD MM YYYY');
            result.push([Date.UTC(dateTime.year(), dateTime.month(), dateTime.date()), item.value])
        }
        if(!result || !result.length){
            return [];
        }
        return result;
    }

    setData(data: any): void {
        this.seriesData = [];
        let total = [];
        for(let type of this.chartTypes){
            this.chartData[type.value] = data[type.value];
            total[type.value] = _.sumBy(data[type.value], function (item) {
                return item.value;
            });
        }
        for(let chart of this.chartTypes){
            let serie = {
                // data: this.mockupData,
                data: this.generateData(data[chart.value]),
                color: chart.color,
                marker: {
                    lineColor: chart.color, // Custom border color for this point
                    lineWidth: 5      // Custom border width for this point
                },
                name:  this.translate.instant(chart.name) + ` (${total[chart.value]})`
            };
            this.seriesData.push(serie);
        }
    }

    navigateRoute() {
        this.router.navigate(['./'], {
            relativeTo: this.route
        });
    }

    sortUsers(column) {
        if (column === 'created_at') {
            column = 'created_at_sort';
        }

        this.sort(column, false);
    }

    generateHighChart(){
        this.setData(this.response);
        this.chartGenerated = true;
        this.chartOptions = {
            chart: {
                type: 'areaspline',
                style: {
                    fontFamily: 'Segoe UI',
                    fontSize: '12px'
                },
            },
            exporting: {
                enabled: false,
            },
            title: {
                // text: this.translate.instant(this.selectedChart['name'])
                text: ''
            },
            xAxis: {
                type: 'datetime'
            },
            yAxis: {
                title: {
                    // text: this.translate.instant('Number')
                    text: ''
                }
            },
            colors: ['#6FD8B10', '#97E3AA', '#EF995C'],
            plotOptions: {
                series: {
                    marker: {
                        symbol: 'circle',
                        enabled: true,
                        radius: 2.5,
                        lineWidth: 5,
                        lineColor: '#000000',
                    },
                }
            },
            series: this.seriesData
        };
    }

    exportToBase64() {
        const latestChart = this.Highcharts.charts.length - 1;
        const chart = this.Highcharts.charts[latestChart] as Highcharts.Chart;
        if (chart) {
            this.chartBase64 = '';
            const svg = chart.getSVG({
                chart: {
                    width: 1280,
                    height: 474
                }
            });
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (ctx) {
                const img = new Image();
                img.onload = () => {
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    const base64Image = canvas.toDataURL('image/png');
                    this.chartBase64 = base64Image;
                    // Use the base64Image string as needed
                };
                img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
            }
        }
    }
}
